import React, { Component } from "react";
import { verHPC9 } from "../../constants/versionManager";
import "./Login.css";
import LoginInput from "./LoginInput";
import OtpCodeInput from "./OtpCodeInput";

class Login extends Component {
   constructor(props) {
      super(props);

      this.state = {
         autologin: this.props.data?.autologin || false,
         username: this.props.username || "",
      };

      this.handleLoginAction = this.handleLoginAction.bind(this);
      this.handleLogoutAction = this.handleLogoutAction.bind(this);
      this.handleToggleChange = this.handleToggleChange.bind(this);
      this.handleVerifyAction = this.handleVerifyAction.bind(this);
      this.handleResendAction = this.handleResendAction.bind(this);
      this.handleWinPopstate = this.handleWinPopstate.bind(this);
   }

   handleToggleChange = (toggleValue) => {
      //this.setState({ autologin: toggleValue });
   };

   handleLoginAction = (username, password, autologin) => {
      this.setState({ username: username, autologin: autologin });
      //Fetchingステータスを監視するタイマを起動、30秒後に
      this.fetchTimerID = this.setFetchTime(30000);
      this.props.login(username, password, autologin);
   };

   handleLogoutAction = () => {
      this.props.logout();
      if (this.fetchTimerID) {
         clearInterval(this.fetchTimerID);
      }
   };

   handleVerifyAction = (otpCode, otpData) => {
      this.props.verifyOtp(otpCode, otpData, this.state.autologin);
      this.fetchTimerID = this.setFetchTime(30000);
   };

   handleResendAction = (username, otpData) => {
      this.props.resendOtp(username, otpData);
      this.fetchTimerID = this.setFetchTime(30000);
   };

   componentDidMount() {
      window.addEventListener("popstate", this.handleWinPopstate);
   }

   componentWillUnmount() {
      window.removeEventListener("popstate", this.handleWinPopstate, false);

      if (this.fetchTimerID) {
         clearInterval(this.fetchTimerID);
      }
   }

   handleWinPopstate = () => {
      if (this.props.data?.isVerifyOtp === true) {
         this.props.logout();
      }
   };

   setFetchTime = (miliSec) => {
      return setInterval(() => {
         this.resetFetchState();
      }, miliSec);
   };

   resetFetchState = () => {
      this.props.resetFetchStateByTimer(false);
   };

   render() {
      const params = new URLSearchParams(window.location.search);
      const page = params.get("p");
    
      if (page === "login" && localStorage.getItem("user")) {
        window.location.href = "index.html";
      }
      
      const {
         isFetching = false,
         data,
         isNotifyMessage = false,
         message,
      } = this.props;
      if (isFetching === false && this.fetchTimerID !== undefined) {
         clearInterval(this.fetchTimerID);
      }

      console.log("render");

      return (
         <div className="container">
            <div className="row">
               <div
                  className="col-md-9 offset-md-1 text-center justify-content-center align-self-center"
                  style={{ marginTop: "20px" }}
               >
                  <font size="6">　 </font>
                  <img
                     src="img/login_logo.png"
                     className="img-fluid"
                     width="150px"
                     height="100px"
                     alt=""
                  />
                  <font size="6"> 端末管理システム</font>
               </div>
            </div>

            <div
               className="row col-md-6 offset-md-3"
               style={{ marginTop: "20px", align: "center" }}
            >
               {message && (
                  <div
                     id="testAlertStyle"
                     className={
                        "alert " +
                        (isNotifyMessage ? "alert-success" : "alert-danger")
                     }
                     style={{ width: "100%" }}
                  >
                     <span style={{ whiteSpace: "pre-wrap" }}>{message}</span>
                  </div>
               )}
               {data && data.isVerifyOtp === true ? (
                  <OtpCodeInput
                     otpCodeLength="6"
                     username={this.state.username}
                     autologin={this.state.autologin}
                     verifyOtp={this.handleVerifyAction}
                     resendOtp={this.handleResendAction}
                     data={data}
                     isFetching={isFetching}
                  />
               ) : (
                  <LoginInput
                     username={this.state.username}
                     autologin={this.state.autologin}
                     login={this.handleLoginAction}
                     logout={this.handleLogoutAction}
                     onToggleChange={this.handleToggleChange}
                     isFetching={isFetching}
                  />
               )}
            </div>

            <div className="row">
               <div className="col-md-9 text-right justify-content-center align-self-center">
                  <br />
                  <font size="4.5">HPC-9 Ver.{verHPC9}</font>
               </div>
            </div>
         </div>
      );
   }
}

export default Login;
